import React, { useState, useContext } from "react";

import Context from "../../Context";
import NestedMenuMUI from "./NestedMenuMUI";

const EsferasMUInestedMenu = () => {
  const { showIcons, setMenuValue } = useContext(Context);

  const handleDeleteAll = () => {
    localStorage.removeItem("localMenuValue");
    setMenuValue([]);
  };

  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ /*  width: 400, */ margin: 20 }}>
            <h4 className="text-center">Diagnóstico por Esferas</h4>
            <br />
            <div className="d-flex justify-content-around mb-5">
              <h6>Esfera</h6>
              <h6>PdA++</h6>
              <h6>Cadena</h6>
            </div>
            <NestedMenuMUI />
          </div>
        </div>
        {showIcons && (
          <div className="icons-card-canvas mb-5">
            <img
              className="icon-trash-canvas"
              src="/assets/images/trash.png"
              alt="icon-image"
              onClick={handleDeleteAll}
            />
            {/* <img
              className="icon-trash-canvas"
              src="/assets/images/icon-download.png"
              alt="icon-image"
              onClick={() => alert("Imagen guardada")}
            /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default EsferasMUInestedMenu;
